var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXiaomi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 200,
    viewBox: "0 0 52.917 52.917",
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 595.28h841.89v-595.28h-841.89z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.35278 0 0 -.35278 -196.1159 155.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4354 0 0 1.4355 -242.08 -126.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m656.46 290.64h-96.563c-2.191 0-3.967 1.776-3.967 3.967v96.563c0 2.191 1.776 3.966 3.967 3.966h96.563c2.191 0 3.967-1.775 3.967-3.966v-96.563c0-2.191-1.776-3.967-3.967-3.967",
    fill: "#ff6700",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m637.87 362.27h-8.221c-.352 0-.637-.28-.637-.625v-37.509c0-.342.285-.622.637-.622h8.221c.349 0 .638.28.638.622v37.509c0 .345-.289.625-.638.625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m609.8 362.27h-31.315c-.352 0-.635-.28-.635-.625v-37.509c0-.342.283-.622.635-.622h8.223c.35 0 .64.28.64.622v29.439c0 .34.283.622.635.622h17.713c4.981 0 6.395-3.815 6.395-6.276v-23.785c0-.342.286-.622.638-.622h8.218c.35 0 .637.28.637.622v26.609c0 2.195-.264 5.351-3.096 8.129-2.963 2.9-5.666 3.396-8.688 3.396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604.04 347.33h-8.633c-.352 0-.641-.28-.641-.623v-22.574c0-.341.289-.621.641-.621h8.633c.349 0 .635.28.635.621v22.574c0 .343-.286.623-.635.623"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXiaomi);
export default __webpack_public_path__ + "static/media/xiaomi.2165a94f821ff7426f5834f5ce07d3da.svg";
export { ForwardRef as ReactComponent };